<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="form-input p-0" :class="{ error: errors.length }">
      <input
        ref="file"
        type="file"
        :accept="accept"
        class="hidden"
        @change="change"
      >
      <div v-if="!modelValue && existingUrl" class="p-2">
        <img
          :src="existingUrl"
          alt=""
          class="mb-2 size-40 rounded object-cover"
        >
        <button
          type="button"
          class="btn-action-edit"
          @click="browse"
        >
          Zmień plik
        </button>
      </div>
      <div v-else-if="!modelValue" class="p-2">
        <button
          type="button"
          class="btn-action-edit"
          @click="browse"
        >
          Wybierz plik
        </button>
      </div>
      <div v-else class="p-2">
        <img
          v-if="objectUrl"
          :src="objectUrl"
          alt=""
          class="mb-2 size-40 rounded object-cover"
        >
        <div class="flex items-center justify-between">
          <div class="flex-1 pr-1 min-w-0">
            <span class="truncate block">{{ modelValue.name }}</span>
            <span class="text-xs text-gray-600">({{ filesize(modelValue.size) }})</span>
          </div>
          <button
            type="button"
            class="btn-action-delete"
            @click="remove"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>
    <div v-if="errors.length" class="form-error">
      {{ errors[0] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: File,
    label: {
      type: String,
      default: null,
    },
    accept: {
      type: String,
      default: null,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    existingUrl: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      objectUrl: null,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.syncPreview(value);
        if (!value) {
          this.$nextTick(() => {
            if (this.$refs.file) {
              this.$refs.file.value = '';
            }
          });
        }
      },
    },
  },
  beforeUnmount() {
    this.revokeObjectUrl();
  },
  methods: {
    syncPreview(value) {
      this.revokeObjectUrl();
      if (value instanceof File && value.type.startsWith('image/')) {
        this.objectUrl = URL.createObjectURL(value);
      }
    },
    revokeObjectUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
    },
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024));
      return (
        (size / Math.pow(1024, i)).toFixed(2) * 1 +
        ' ' +
        ['B', 'kB', 'MB', 'GB', 'TB'][i]
      );
    },
    browse() {
      this.$refs.file.click();
    },
    change(e) {
      this.$emit('update:modelValue', e.target.files[0]);
    },
    remove() {
      this.$emit('update:modelValue', null);
    },
  },
};
</script>
